let requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame
let callbacks = []
let running = false

let resize = function() {
  if (!running) {
    running = true

    if (requestAnimationFrame) {
      requestAnimationFrame(runCallbacks)
    } else {
      setTimeout(runCallbacks, 66)
    }
  }
}

let runCallbacks = function() {
  callbacks.forEach(function(callback) {
    callback(this)
  })

  running = false
}

let addCallback = function(callback) {
  if (callback) {
    callbacks.push(callback)
  }
}

class ResizeHelper {
  constructor(callback) {
    if (!callbacks.length) {
      window.addEventListener('resize', resize)
    }
    addCallback(callback)
  }
  destroy() {
    window.removeEventListener('resize', resize)
  }
}

export default ResizeHelper
